import React, {useEffect} from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { reveal } from "./utils";
import { revealTwo } from "./utils";
import { fromUp } from "./utils";
import { useScroll } from "./useScroll";
import { motion } from "framer-motion";

import image from './images/profile-pic.jpg'

function About() {

    const [element, controls] = useScroll();

    useEffect( () => {
        Aos.init({duration: 2000, offset: 400})
    }, [])
    return (
        <div className='about-container' ref={element}>
            <div data-aos='fade-right' className='sub-header'>
                <h3>About me</h3>
            </div>
            <div>
            <motion.div
             initial="hidden"
             animate="show"
             animate={controls}
             variants={reveal}
             transition={{ ease: 'easeInOut', delay: 0.1, duration: .8, stiffness: 300 }}
            >
                <p>
                Hello! Tosin is my name, and I adore making things for the internet. My interest in web development began in 2015. Unfortunately, due to my schoolwork, I was unable to further my knowledge, but the need to express myself creatively taught me a lot about HTML and CSS!
                </p>
                <p>
                Fast forward to now, I've amassed thousands of learning hours on a project-based fullstack JavaScript curriculum offered by <a href='https://www.theodinproject.com/paths/full-stack-javascript/courses/javascript' target='_blank'>The Odin Project</a>, allowing me to gain expertise about web development. JavaScript is my primary programming language, and I have a lot of projects on my <a href='https://github.com/Alat-star?tab=repositories' target='_blank'>Github</a> account that illustrate my command of it.                
                </p>
               {/* <p>
                I also recently launched a course that covers everything you need to build a web app with the Spotify API using Node & React.
                </p> */}
                <p>
                Here are a few technologies I’ve been working with recently:
                </p>
                <div data-aos='flip-right' className='skills-div'>
                    <div>
                        <ol>
                            <li><span><FontAwesomeIcon icon={["fa", "check-square"]}  /></span>JavaScript (ES6+)</li>
                            <li><span><FontAwesomeIcon icon={["fa", "check-square"]} /></span>Webpack</li>
                            <li><span><FontAwesomeIcon icon={["fa", "spinner"]} pulse /></span>Redux</li>
                            <li><span><FontAwesomeIcon icon={["fa", "spinner"]} pulse /></span>Kotlin</li>
                        </ol>
                    </div>
                    <div>
                        <ol>
                            <li><span><FontAwesomeIcon icon={["fa", "check-square"]} /></span>Firebase</li>
                            <li><span><FontAwesomeIcon icon={["fa", "check-square"]} /></span>React</li>
                            <li><span><FontAwesomeIcon icon={["fa", "spinner"]} pulse /></span>Node</li>
                            <li><span><FontAwesomeIcon icon={["fa", "check-square"]} /></span>Jest</li>
                        </ol>
                    </div>
                </div>
            </motion.div>
            <div ref={element}>
                <motion.div
                variants={revealTwo}
                initial="hidden"
                animate="show"
                animate={controls}
                // variants={reveal}
                transition={{ease: 'easeInOut', delay: .1, duration: 1.5, stiffness: 300 }}
                >
                    <img alt='my picture' src='https://firebasestorage.googleapis.com/v0/b/secondportofolio.appspot.com/o/IMG_20211026_062945_281.jpg?alt=media&token=a5ab18e1-e2d1-4024-bb79-15f0a4f52ae4' />
                    <div className='div-img-overlay'></div>
                </motion.div>
            </div>
            </div>
        </div>
    )
}

export default About
